import React, { useState, useEffect } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import {
  Button,
} from "@material-ui/core";
import { Link } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import {useHistory} from "react-router-dom";
import moment from "moment-timezone";
import MobileStepper from '@material-ui/core/MobileStepper';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { userService } from "./../../services/user.service";
import images from "./../../common/images";
import SinglePageViewer from "../pdfviewer/single-page"
import {useSnackbar} from "notistack";
import {useAppDispatch} from "../../redux/store";
import {createUserProfile} from "../../redux/userProfile/userProfile.actions";
import API from "../../helpers/apiHelpers";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    button: {
      marginRight: theme.spacing(1),
      borderRadius:'40px !important',
      height: '50px !important',
      width: '150px !important',
      color:'#FFFFFF !important',
      backgroundColor: '#273878 !important',
      marginTop:'50px'
    },
    backButton : {
      backgroundColor: '#FFFFFF !important',
    },
    closeButton: {
      backgroundColor: '#273878',
      border: 'none',
      color: 'white',
      padding: '15px 32px',
      textAlign: 'center',
      textDecoration: 'none',
      display: 'inline-block',
      fontSize: '22px',
      fontWeight: 800,
      borderRadius: '15px',
    },
    completed: {
      display: 'inline-block',
    },
    instructions: {
      // fontFamily:'Bogart',
      fontSize:'24px',
      lineHeight:'30px',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      color:'#273878',
    },
    StepName:{
      // fontFamily:'Bogart Italic',
    },
    StepTitle:{
      // fontFamily:'Bogart Extrabold Italic',
      fontWeight:800,
      fontSize:'24px',
      lineHeight:'30px',
    },
    StepBodyTxt:{
      // fontFamily:'Bogart Regular',
      fontSize:'18px',
      lineHeight:'26px',
      letterSpacing: '0',
    },
    row:{
      display: 'flex',
    },
    left:{
      width: '10%',
      padding: '10px',
      textAlign:'right',
    },
    right:{
      width: '90%',
      padding: '10px',
    },
    formLabels:{
      // fontFamily:'Bogart Medium',
      fontSize: '18px',
      color: '#273878',
      justifyContent: 'space-between',
      margin:"50px 0px",
      display:'table-cell'
    },
    lastStep: {
      textAlign:"center",
    },
  }),
);

let completedSteps: number[] = [];

const getSteps = () => {
  return [
    "Welcome Packet",
    "Scheduling Via Sling",
    "Set Up Square (our payment system)",
    "Set Up Hello Ralphie Account",
    "Learn How to Use the Hello Ralphie Platform",
    "Issuing a Refund",
    "Sending an Invoice",
    "Schedule a Meeting",
  ];
};

const getStepContent = (step: number) => {
  switch (step) {
    // case 0:
    //   return "You will receive an email from Hello Ralphie with the service agreement for you to review, sign and return.";
    // case 1:
    //   return "Tell us more about you";
    // case 2:
    //     return "Please fill the address to complete the information";
    case 0:
      return "Please read through the Welcome Packet";
    case 1:
      return "Watch this Sling Video (~3 minutes)";
    case 2:
      return "Follow this step-by-step guide to properly set up your Square account";
    case 3:
      return "Please follow these step-by-step instructions to set up your provider account via an IOS device.";
    case 4:
      return "Please follow these step-by-step instructions to learn how to use the Hello Ralphie Platform";
    case 5:
      return "If you need to refund an appointment, you can follow these step-by-step instructions.";
    case 6:
      return "Please follow these step-by-step instructions to learn how to send an invoice using Square";
    case 7:
        return "";

    default:
      return "Unknown step";
  }

};

const step1 = ['firstName','lastName','phoneNumber','bestWayToBeReached']
const step2 = ['address','city','state','zipcode']

interface IUserDetails {
  firstName?: string,
  lastName?: string,
  phoneNumber?: string,
  bestWayToBeReached?:string,
  locationTimeZone?: string,
  practiceCode?: string,
  speciality?: Array<string>,
  states?: Array<string>,
  vetProfileStatus?: string,
  vetSpecialInterests?: Array<string>,
  workDays?: Array<string>,
  type? : string
}

interface IUserAddress {
  userId?: number,
  type?: string,
  name?: string,
  firstLine?: string,
  secondLine?: string
  city?: string,
  state?: string,
  zipCode?: string,
  countryString?: string,
}

export const ContentStepper = (props: any) => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const profileDetails: IUserDetails = {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    bestWayToBeReached: "",
    locationTimeZone: "",
    practiceCode: "",
    speciality: [],
    states: [],
    vetProfileStatus: "",
    vetSpecialInterests: [],
    workDays: [],
    type: "",
  };
  const addrDetails: IUserAddress = {
    userId: 0,
    type: "",
    name: "",
    firstLine: "",
    secondLine: "",
    city: "",
    state: "",
    zipCode: "",
    countryString: ""
  };
  const [userDetails, setUserDetails] = useState(profileDetails);
  const [userAddressDetails, setUserAddressDetails] = useState(addrDetails);
  const [userHasAddress, setUserHasAddress] = useState(false);
  const [profileId, setProfileId] = useState(0);
  const [activeStep, setActiveStep] = useState(!!props.query.length ? Number(props.query) : 0);
  const { enqueueSnackbar } = useSnackbar();
  const userData = JSON.parse(localStorage.getItem("auth") || "{}");
  useEffect(() => {
    !!props.query.length && setActiveStep(Number(props.query));
  }, [props.query])
  useEffect(() => {
    if (userData && userData.userId) {
      userService.getProfileById(userData.userId)
        .then(async (resp) => {
          const data = resp[0];
          const id = userData.userId
          if (resp[0]?.firstName?.length &&
              resp[0]?.lastName?.length &&
              resp[0]?.summary?.length &&
              resp[0]?.speciality?.length &&
              resp[0]?.education?.length &&
              resp[0]?.phoneNumber?.length
          )
            localStorage.setItem("onboarded", true);
          else localStorage.setItem("onboarded", true);
          console.log("qw", resp);
          if (!data) {
            console.log("qwe");
              const profile = JSON.parse(localStorage.getItem("profile"));
              await dispatch(createUserProfile({
                userId: userData.userId,
                firstName: profile?.firstName,
                lastName: profile?.lastName,
                practiceCode: profile?.practiceCode,
                type: "vet",
                locationTimeZone: moment.tz.guess(),
                workDays: [
                  {
                    workdayBegins: moment().toISOString(),
                    workdayEnds: moment().add(3, "hours").toISOString()
                  }
                ]
              }));
          }
          // set phone and bestway to be reached
          profileDetails.firstName = data.firstName;
          profileDetails.lastName = data.lastName;
          profileDetails.phoneNumber = data.phoneNumber;
          profileDetails.bestWayToBeReached = data.bestWayToBeReached;
          profileDetails.locationTimeZone = data.locationTimeZone;
          profileDetails.practiceCode = data.practiceCode;
          profileDetails.specialty = data.specialty;
          profileDetails.states = data.states;
          profileDetails.vetProfileStatus = data.vetProfileStatus;
          profileDetails.vetSpecialInterests = data.vetSpecialInterests;
          profileDetails.workDays = data.workDays;
          profileDetails.type = data.type;
          setUserDetails(profileDetails);
          setProfileId(data.id);
        }).catch((err) => {
          // TODO handle this better
          console.error(err);
        });
      userService.getAddressById(userData.userId)
        .then((resp) => {
          addrDetails.userId = userData.userId;
          if (resp.length > 0) {
            const data = resp[0];
            addrDetails.id = data.id;
            addrDetails.type = data.type;
            addrDetails.name = data.name;
            addrDetails.firstLine = data.firstLine;
            addrDetails.secondLine = data.secondLine;
            addrDetails.city = data.city;
            addrDetails.state = data.state;
            addrDetails.zipCode = data.zipCode;
            addrDetails.countryString = data.countryString;
            setUserHasAddress(true);
          }
          setUserAddressDetails(addrDetails);
        }).catch((err) => {
          console.error(err);
        });
    }
  },[]);
  let reachedEnd  = false;

  const { content, query } = props;

  const totalSteps = () => {
    return content.length;
  };

  const capitalizeFirstLetter = (name : string) => {
    return name.charAt(0).toUpperCase() + name.slice(1);
  }

  const getImgPath = (name : string) =>{
    let path : string | undefined;
    images.forEach((image) => {
      if(capitalizeFirstLetter(image.name) === name) {
        path = image.value;
      }
    })
    return path;
  }

  const isLastStep = () => {
    return activeStep === 7;
  };

  function isEmpty(step :Array<string>) {
    for (let key of step) {
      if (userData[key] === null || userData[key] === "")
        return true;
    }
    return false;
  }

  const handleNext = () => {
    if(activeStep === 1){
      if(isEmpty(step1)){
        return;
      }
      userService.updateProfileById(profileId, userDetails)
        .then((resp) => {
          console.log("updated successfully");
        }).catch((err) => {
          // TODO handle errors properly, show alert or something of the like
          console.log("failed to update");
          console.error(err);
      });
    }
    else if(activeStep === 2){
      if(isEmpty(step2)){
        return;
      }

      const payload = {
        firstLine: userAddressDetails.firstLine,
        zipCode: userAddressDetails.zipCode,
        city: userAddressDetails.city,
        state: userAddressDetails.state,
      };
      if (!userHasAddress) {
        payload.userId = userAddressDetails.userId;
        userService.createUserAddress(payload)
          .then((resp) => {
            console.log("successfully created address");
            setUserHasAddress(true);
          }).catch((err) => {
            console.log("error creating address");
          });
      } else {
        userService.updateAddressById(userAddressDetails.id, payload)
          .then((resp) => {
          console.log("updated successfully");
          }).catch((err) => {
            // TODO handle errors properly, show alert or something of the like
            console.log("failed to update");
            console.error(err);
          });
      }
    }
    else {
      // if(!completedSteps.includes(activeStep)){
      //   return;
      // }
    }

    completedSteps.push(activeStep)
    const newActiveStep = activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleUserDetailsInput = (event: React.SyntheticEvent) => {
    const { name, value } = (event.currentTarget as HTMLInputElement);
    let newUserDetails = Object.assign({}, userDetails);
    newUserDetails[name] = value;
    setUserDetails(newUserDetails);
  }

  const handleUserAddressInput = (event: React.SyntheticEvent) => {
    const { name, value } = (event.currentTarget as HTMLInputElement);
    let newAddressDetails = Object.assign({}, userAddressDetails);
    newAddressDetails[name] = value;
    setUserAddressDetails(newAddressDetails);
  }

  const handleSelOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = (event.target);
    let newUserDetails = Object.assign({}, userDetails);
    let newVal = value;
    if (name === "bestWayToBeReached") {
      newVal = newVal.toUpperCase();
    }
    newUserDetails[name] = newVal;
    setUserDetails(newUserDetails);
  }

  const reachedLastPage = () =>{
    reachedEnd = true;
  }

  const validateField = (fieldName, srcObj, type) =>{
    let errMsg = '';
    if(srcObj[fieldName] !== ""){
      if(type === 'text'){
        if(!srcObj[fieldName].match("[a-zA-Z]+")){
          errMsg = "This field only takes alphabets.";
          return errMsg;
        }
      }
      if(type === 'phone') {
        if(!srcObj[fieldName].match("^[0-9]{10}$")){
          errMsg = "Please enter 10 digits";
          return errMsg;
        }
      }
    } else {
      errMsg = "This is a required field.";
      return errMsg;
    }
    return errMsg;
  }
  const MenuProps = {
    PaperProps: {
      style: {
        width: "100%",
      },
    },
  };
  return (
    // HTML content and step logic here
    <div className={classes.root}>
      <div>
        <div className={classes.row}>
          <div className={classes.left}>
          </div>
          <div className={classes.right}>
            <div className={classes.instructions+ ' ' + classes.StepTitle}>{getSteps()[activeStep]}</div>
              <div className={classes.instructions + ' ' + classes.StepBodyTxt}>{getStepContent(activeStep)}</div>
            {isLastStep() ? (
                  <div>
                    <div>
                      <p>To schedule a meeting with Felicity, please use the following link: <a href="https://calendly.com/felicity-johnson/15min" target="_blank" rel="noreferrer">https://calendly.com/felicity-johnson/15min</a></p>
                      </div>
                    </div>
                  ) : (activeStep === 6) ? (
                    <div>{/* all data from content goes here */}
                      <SinglePageViewer pdf={getImgPath("Sending an Invoice")}/>
                   </div>
                  ) : (
                  <div className={classes.pdfDisplay} style={{ width: "100%", minHeight: "500px"}}>
                    {content[activeStep + 3].videos[0].url !== "" ? (
                        <div style={{ width:"100%", height: "100%"}}>
                            <iframe
                              src={content[activeStep + 3].videos[0].url}
                              title="sling"
                              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                              frameBorder="0"
                              width="100%"
                              height="500px"
                              webkitallowfullscreen="true"
                              mozallowfullscreen="true"
                              allowFullScreen
                            />
                        </div>
                      ) :(
                        <div>{/* all data from content goes here */}
                          <SinglePageViewer pdf={getImgPath(content[activeStep + 3].links[0].url)} onReachedLastpage={reachedLastPage}/>
                        </div>
                      )
                    }
                  </div>
                )
            }
            {
              isLastStep() ? (
              null
              ) : (
                <MobileStepper
                  variant="progress"
                  steps={totalSteps()}
                  position="static"
                  activeStep={activeStep}
                  className={classes.root}
                  nextButton={
                    <Button style={{visibility: isLastStep() ? "hidden" : "visible" }} className={classes.button} size="small" onClick={handleNext} disabled={isLastStep()}>
                      Next
                      <KeyboardArrowRight />
                    </Button>
                  }
                  backButton={
                    <Button style={{visibility: activeStep === 0 || isLastStep() ? "hidden" : "visible" }} className={`${classes.button} backButton`} size="small" onClick={handleBack} disabled={activeStep === 0}>
                      <KeyboardArrowLeft />
                      Back
                    </Button>
                  }
                />
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};
